import 'date-fns';
import React from 'react';
import DateFnsUtils from '@date-io/date-fns';
import './DatePicker.css';
import Button from '@material-ui/core/Button';

import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';

import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles({
  root: {
    border: 0,
    borderRadius: 3,
    color: 'white',
    background: 'white',
    padding: '0 30px',
  },
});


export default function DatePicker(props) {
    // The first commit of Material-UI
    const [selectedDate, setSelectedDate] = React.useState(new Date());
    const classes = useStyles();

    const handleDateChange = date => {
        setSelectedDate(date);
        let curDate = date;
        if(props.start){
            curDate.setHours(0,0,0); //start of day
        }else{
            curDate.setHours(23,59,59); //end of date
        }
        if(props.callback){
            props.callback(props.name, {value : curDate.getTime()})
        }
    };

    const handleRemoval = () => {
        console.log("handleRemoval");
        if(props.removeCallback){
            props.removeCallback(props.name);
        }
    };

    return (
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                {props.removeCallback ? <Button variant="contained" className="DatePicker-button" onClick={handleRemoval}>X</Button>: ""}
                <KeyboardDatePicker
                    className={classes.root}
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id={props.name}
                    label={props.title}
                    value={selectedDate}
                    onChange={handleDateChange}
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}
                />
            </MuiPickersUtilsProvider>
    );
}